import { Injectable } from '@angular/core';
import { environment } from '@env';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';

@Injectable({
  providedIn: 'root'
})
export class SessionApiService extends ApiService {
  readonly resourcePath = 'sessions';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<any>> {
    return this.restList<any>(filters);
  }

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }

  getPublic(id: string): Observable<any> {
    return this.http.get(this.resourceUrl + '/' + id + '/info');
  }

  create(session: object): Observable<any> {
    return this.restCreate<any>(session);
  }

  update(id: string, session: object): Observable<any> {
    return this.restUpdate<any>(id, session);
  }

  getParticipants(sessionId: string): Observable<any> {
    return this.http.get(environment.apiUrl + '/me/courses/participants/' + sessionId);
  }
}
